import { useState } from 'react';

export default function SolutionsSection() {
  const [activePopup, setActivePopup] = useState<string | null>(null);

  const scrollToDiagnostic = () => {
    const element = document.getElementById('diagnostico');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToDiagnosticAndClosePopup = () => {
    setActivePopup(null); // Fecha o popup primeiro
    setTimeout(() => {
      const element = document.getElementById('diagnostico');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Pequeno delay para garantir que o popup feche antes do scroll
  };

  const openWhatsApp = () => {
    const phoneNumber = '551123746167';
    const message = encodeURIComponent('Olá! Vim pelo site da M4 Digital e gostaria de mais informações sobre os serviços.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const solutions = [
    {
      icon: 'ri-advertisement-line',
      title: 'Tráfego Pago Inteligente',
      description: 'Campanhas otimizadas com IA para máximo ROI e conversões qualificadas.',
      features: ['Google Ads', 'Facebook Ads', 'LinkedIn Ads', 'Otimização por IA'],
      color: 'green',
      id: 'trafego-pago'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'CRM & Automação',
      description: 'Gestão completa de leads com automações que nutrem e convertem.',
      features: ['Pipeline Automatizado', 'Lead Scoring', 'Follow-up Inteligente', 'Relatórios Avançados'],
      color: 'red',
      id: 'crm-automacao'
    },
    {
      icon: 'ri-robot-line',
      title: 'Agentes de IA',
      description: 'Assistentes virtuais que qualificam leads e agendam reuniões 24/7.',
      features: ['Chatbots Inteligentes', 'Qualificação Automática', 'Agendamento', 'Integração WhatsApp'],
      color: 'yellow',
      id: 'agentes-ia'
    },
    {
      icon: 'ri-whatsapp-line',
      title: 'WhatsApp API',
      description: 'Automações completas no WhatsApp para vendas e atendimento.',
      features: ['Mensagens Automáticas', 'Catálogo Digital', 'Pagamentos', 'Suporte 24h'],
      color: 'green',
      id: 'whatsapp-api'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Lançamentos Estratégicos',
      description: 'Estratégias completas para lançamento de produtos e serviços.',
      features: ['Planejamento Completo', 'Funis de Conversão', 'Campanhas Integradas', 'Análise de Resultados'],
      color: 'orange',
      id: 'lancamentos'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Reativação de Leads',
      description: 'Recupere leads dormentes com estratégias personalizadas.',
      features: ['Segmentação Avançada', 'Campanhas Personalizadas', 'Ofertas Especiais', 'Remarketing'],
      color: 'red',
      id: 'reativacao-leads'
    }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      orange: 'bg-orange-100 text-orange-600 group-hover:bg-orange-600 group-hover:text-white',
      red: 'bg-red-100 text-red-600 group-hover:bg-red-600 group-hover:text-white',
      yellow: 'bg-yellow-100 text-yellow-600 group-hover:bg-yellow-600 group-hover:text-white',
      green: 'bg-green-100 text-green-600 group-hover:bg-green-600 group-hover:text-white'
    };
    return colors[color as keyof typeof colors] || colors.orange;
  };

  const handleSaibaMais = (solutionId: string) => {
    if (solutionId === 'trafego-pago' || solutionId === 'crm-automacao' || solutionId === 'agentes-ia' || solutionId === 'whatsapp-api' || solutionId === 'lancamentos' || solutionId === 'reativacao-leads') {
      setActivePopup(solutionId);
    }
  };

  const closePopup = () => {
    setActivePopup(null);
  };

  return (
    <>
      <section className="py-20 bg-white" id="solucoes">
        <div className="container">
          {/* Header */}
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Nossas
              <span className="gradient-text-orange"> Soluções</span>
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Tecnologias avançadas e estratégias comprovadas para acelerar o crescimento do seu negócio
            </p>
          </div>

          {/* Solutions Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {solutions.map((solution, index) => (
              <div 
                key={index}
                className="group bg-white rounded-2xl p-8 border border-gray-200 hover:border-orange-300 card-hover hover:shadow-orange-100"
              >
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center mb-6 transition-all duration-300 ${getColorClasses(solution.color)}`}>
                  <i className={`${solution.icon} text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {solution.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {solution.description}
                </p>
                
                <ul className="space-y-2 mb-6">
                  {solution.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-check-line text-orange-500"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <button 
                  onClick={() => handleSaibaMais(solution.id)}
                  className="w-full py-3 px-4 border border-orange-300 rounded-lg text-orange-600 font-medium hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Saiba Mais
                </button>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-8 lg:p-12 text-center text-white">
            <h3 className="text-3xl lg:text-4xl font-bold mb-4">
              Pronto para Acelerar suas Vendas?
            </h3>
            <p className="text-xl mb-8 opacity-90">
              Agende uma consultoria gratuita e descubra como podemos transformar seus resultados
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={scrollToDiagnostic}
                className="bg-white text-orange-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-line mr-2"></i>
                Agendar Consultoria Gratuita
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Tráfego Pago Popup */}
      {activePopup === 'trafego-pago' && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closePopup();
            }
          }}
        >
          <div className="relative max-w-5xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-white rounded-2xl shadow-2xl">
              {/* Header */}
              <div className="relative bg-gradient-to-r from-orange-500 to-red-500 p-8 rounded-t-2xl text-white">
                <button 
                  onClick={closePopup}
                  className="absolute top-4 right-4 text-white hover:text-gray-200 text-2xl w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line"></i>
                </button>
                
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center">
                    <i className="ri-advertisement-line text-3xl"></i>
                  </div>
                  <div>
                    <h2 className="text-3xl font-bold">🚀 Tráfego Pago com Inteligência de Dados e IA</h2>
                    <p className="text-xl opacity-90 mt-2">A nova geração da performance digital chegou.</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="grid lg:grid-cols-2 gap-8">
                  {/* Left Content */}
                  <div className="space-y-6">
                    <div>
                      <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        Na M4 Digital, não fazemos apenas anúncios — <strong>construímos máquinas de geração de oportunidades</strong>.
                        Combinamos Inteligência de Dados, Inteligência Artificial e Neurovendas para atrair os clientes certos, no momento certo, com a mensagem certa.
                      </p>
                      
                      <p className="text-gray-700 leading-relaxed mb-6">
                        Nossas campanhas são otimizadas por modelos de IA que aprendem continuamente com o comportamento do público, analisam padrões de conversão e ajustam automaticamente os investimentos para maximizar o retorno sobre o investimento (ROI).
                      </p>
                      
                      <p className="text-gray-700 leading-relaxed mb-6">
                        <strong>Enquanto muitos anunciam para todos, nós miramos apenas em quem tem real potencial de compra.</strong>
                      </p>
                      
                      <p className="text-gray-700 leading-relaxed">
                        Nosso foco é gerar leads altamente qualificados, prontos para o fechamento e com alto índice de conversão — reduzindo o custo por aquisição e acelerando o crescimento da sua empresa.
                      </p>
                    </div>

                    {/* Diferenciais */}
                    <div className="bg-gray-50 rounded-xl p-6">
                      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-star-line text-orange-500"></i>
                        Diferenciais M4 Digital:
                      </h3>
                      
                      <div className="space-y-4">
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-target-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Segmentação avançada por intenção e comportamento de compra.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-robot-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Otimização contínua de campanhas com IA e dados em tempo real.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-links-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Integração com CRM e automações para rastrear e nutrir leads até a venda.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-bar-chart-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Relatórios inteligentes que transformam dados em decisões estratégicas.</p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-6 border border-orange-200">
                      <p className="text-lg font-semibold text-gray-900 text-center">
                        Com a M4 Digital, seu tráfego deixa de ser um gasto e se transforma em uma 
                        <span className="text-orange-600"> máquina previsível de geração de vendas com inteligência</span>.
                      </p>
                    </div>
                  </div>

                  {/* Right Content - Dashboard Image */}
                  <div className="space-y-6">
                    <div className="bg-gray-900 rounded-xl p-6">
                      <img 
                        src="https://readdy.ai/api/search-image?query=Modern%20digital%20marketing%20analytics%20dashboard%20with%20AI-powered%20traffic%20management%20interface%2C%20real-time%20campaign%20performance%20metrics%2C%20conversion%20tracking%20charts%2C%20ROI%20optimization%20graphs%2C%20orange%20and%20red%20color%20scheme%2C%20professional%20business%20intelligence%20visualization%2C%20data-driven%20insights%20display%2C%20automated%20bidding%20controls%2C%20lead%20quality%20scoring%20interface&width=600&height=400&seq=traffic-dashboard&orientation=landscape"
                        alt="Dashboard de Análise de Tráfego M4 Digital"
                        className="w-full h-64 object-cover rounded-lg"
                      />
                      <div className="mt-4 text-center">
                        <p className="text-white text-sm">Dashboard Inteligente M4 Digital</p>
                        <p className="text-gray-400 text-xs">Análise em tempo real com IA</p>
                      </div>
                    </div>

                    {/* Metrics Cards */}
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-orange-50 rounded-lg p-4 text-center border border-orange-200">
                        <div className="text-2xl font-bold text-orange-600">+300%</div>
                        <div className="text-sm text-gray-600">ROI Médio</div>
                      </div>
                      <div className="bg-red-50 rounded-lg p-4 text-center border border-red-200">
                        <div className="text-2xl font-bold text-red-600">-60%</div>
                        <div className="text-sm text-gray-600">Custo por Lead</div>
                      </div>
                      <div className="bg-yellow-50 rounded-lg p-4 text-center border border-yellow-200">
                        <div className="text-2xl font-bold text-yellow-600">85%</div>
                        <div className="text-sm text-gray-600">Taxa de Conversão</div>
                      </div>
                      <div className="bg-green-50 rounded-lg p-4 text-center border border-green-200">
                        <div className="text-2xl font-bold text-green-600">24h</div>
                        <div className="text-sm text-gray-600">Otimização IA</div>
                      </div>
                    </div>

                    {/* CTA Buttons */}
                    <div className="space-y-3">
                      <button 
                        onClick={scrollToDiagnosticAndClosePopup}
                        className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-4 px-6 rounded-lg font-semibold hover:from-orange-600 hover:to-red-600 transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-calendar-line mr-2"></i>
                        Agendar Consultoria Gratuita
                      </button>
                      <button 
                        onClick={openWhatsApp}
                        className="w-full border-2 border-orange-500 text-orange-600 py-4 px-6 rounded-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-whatsapp-line mr-2"></i>
                        Falar com Especialista
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CRM & Automação Popup */}
      {activePopup === 'crm-automacao' && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closePopup();
            }
          }}
        >
          <div className="relative max-w-5xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-white rounded-2xl shadow-2xl">
              {/* Header */}
              <div className="relative bg-gradient-to-r from-red-500 to-orange-500 p-8 rounded-t-2xl text-white">
                <button 
                  onClick={closePopup}
                  className="absolute top-4 right-4 text-white hover:text-gray-200 text-2xl w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line"></i>
                </button>
                
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center">
                    <i className="ri-customer-service-line text-3xl"></i>
                  </div>
                  <div>
                    <h2 className="text-3xl font-bold">⚙️ CRM e Automação de Vendas com Inteligência Estratégica</h2>
                    <p className="text-xl opacity-90 mt-2">Transforme o caos comercial em um processo previsível, automatizado e lucrativo.</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="grid lg:grid-cols-2 gap-8">
                  {/* Left Content */}
                  <div className="space-y-6">
                    <div>
                      <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        Na M4 Digital, não apenas implementamos um CRM — <strong>implantamos a estrutura completa do seu processo comercial</strong>, do primeiro contato até o pós-venda.
                        Cada etapa é desenhada sob medida para o seu negócio, com automação inteligente, integração entre sistemas e visão total da jornada do cliente.
                      </p>
                      
                      <p className="text-gray-700 leading-relaxed mb-6">
                        Nossa metodologia une estratégia, tecnologia e neurovendas para criar um funil automatizado de alta conversão, onde nenhuma oportunidade é perdida.
                      </p>
                    </div>

                    {/* O que entregamos */}
                    <div className="bg-gray-50 rounded-xl p-6">
                      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-settings-line text-red-500"></i>
                        O que entregamos:
                      </h3>
                      
                      <div className="space-y-4">
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-database-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Implementação completa do CRM (Lovoo ou outro sistema compatível).</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-flow-chart text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Criação de fluxos automatizados de prospecção, qualificação e follow-up.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-links-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Integração com WhatsApp, e-mail, planilhas, ERP e ferramentas internas.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-dashboard-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Painéis de gestão em tempo real, com indicadores e relatórios estratégicos.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-graduation-cap-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Treinamento e suporte personalizado para garantir domínio total da operação.</p>
                        </div>
                      </div>
                    </div>

                    {/* Resultados esperados */}
                    <div className="bg-gradient-to-r from-red-50 to-orange-50 rounded-xl p-6 border border-red-200">
                      <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-trophy-line text-red-500"></i>
                        Resultados esperados:
                      </h3>
                      
                      <div className="space-y-3">
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-red-500"></i>
                          <p className="text-gray-700">Redução drástica de tarefas manuais.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-red-500"></i>
                          <p className="text-gray-700">Aumento da produtividade e do volume de oportunidades.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-red-500"></i>
                          <p className="text-gray-700">Processos comerciais claros, previsíveis e escaláveis.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-red-500"></i>
                          <p className="text-gray-700">Times de vendas mais ágeis, organizados e focados no fechamento.</p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gradient-to-r from-red-50 to-orange-50 rounded-xl p-6 border border-red-200">
                      <p className="text-lg font-semibold text-gray-900 text-center">
                        Com o CRM e automações da M4 Digital, sua empresa ganha uma 
                        <span className="text-red-600"> máquina de vendas estruturada, que trabalha sozinha</span> — enquanto sua equipe foca no que realmente importa: vender mais.
                      </p>
                    </div>
                  </div>

                  {/* Right Content - CRM Dashboard Image */}
                  <div className="space-y-6">
                    <div className="bg-gray-900 rounded-xl p-6">
                      <img 
                        src="https://readdy.ai/api/search-image?query=Sophisticated%20CRM%20automation%20dashboard%20interface%20with%20sales%20pipeline%20visualization%2C%20lead%20management%20system%2C%20automated%20workflow%20charts%2C%20customer%20journey%20mapping%2C%20real-time%20analytics%2C%20red%20and%20orange%20color%20scheme%2C%20modern%20business%20intelligence%20platform%2C%20contact%20management%20interface%2C%20sales%20funnel%20tracking%2C%20automated%20follow-up%20sequences&width=600&height=400&seq=crm-dashboard&orientation=landscape"
                        alt="Dashboard CRM e Automação M4 Digital"
                        className="w-full h-64 object-cover rounded-lg"
                      />
                      <div className="mt-4 text-center">
                        <p className="text-white text-sm">CRM Inteligente M4 Digital</p>
                        <p className="text-gray-400 text-xs">Automação completa de vendas</p>
                      </div>
                    </div>

                    {/* Metrics Cards */}
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-red-50 rounded-lg p-4 text-center border border-red-200">
                        <div className="text-2xl font-bold text-red-600">-80%</div>
                        <div className="text-sm text-gray-600">Tarefas Manuais</div>
                      </div>
                      <div className="bg-orange-50 rounded-lg p-4 text-center border border-orange-200">
                        <div className="text-2xl font-bold text-orange-600">+250%</div>
                        <div className="text-sm text-gray-600">Produtividade</div>
                      </div>
                      <div className="bg-yellow-50 rounded-lg p-4 text-center border border-yellow-200">
                        <div className="text-2xl font-bold text-yellow-600">95%</div>
                        <div className="text-sm text-gray-600">Follow-up Automático</div>
                      </div>
                      <div className="bg-green-50 rounded-lg p-4 text-center border border-green-200">
                        <div className="text-2xl font-bold text-green-600">100%</div>
                        <div className="text-sm text-gray-600">Leads Rastreados</div>
                      </div>
                    </div>

                    {/* CTA Buttons */}
                    <div className="space-y-3">
                      <button 
                        onClick={scrollToDiagnosticAndClosePopup}
                        className="w-full bg-gradient-to-r from-red-500 to-orange-500 text-white py-4 px-6 rounded-lg font-semibold hover:from-red-600 hover:to-orange-600 transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-calendar-line mr-2"></i>
                        Agendar Consultoria Gratuita
                      </button>
                      <button 
                        onClick={openWhatsApp}
                        className="w-full border-2 border-red-500 text-red-600 py-4 px-6 rounded-lg font-semibold hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-whatsapp-line mr-2"></i>
                        Falar com Especialista
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Agentes de IA Popup */}
      {activePopup === 'agentes-ia' && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closePopup();
            }
          }}
        >
          <div className="relative max-w-5xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-white rounded-2xl shadow-2xl">
              {/* Header */}
              <div className="relative bg-gradient-to-r from-yellow-500 to-orange-500 p-8 rounded-t-2xl text-white">
                <button 
                  onClick={closePopup}
                  className="absolute top-4 right-4 text-white hover:text-gray-200 text-2xl w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line"></i>
                </button>
                
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center">
                    <i className="ri-robot-line text-3xl"></i>
                  </div>
                  <div>
                    <h2 className="text-3xl font-bold">🤖 Agentes de Inteligência Artificial Sob Medida</h2>
                    <p className="text-xl opacity-90 mt-2">Automação inteligente para cada etapa do seu processo comercial.</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="grid lg:grid-cols-2 gap-8">
                  {/* Left Content */}
                  <div className="space-y-6">
                    <div>
                      <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        Na M4 Digital, desenvolvemos <strong>Agentes de IA personalizados sob medida</strong> para automatizar tarefas, reduzir custos operacionais e aumentar a lucratividade do seu negócio.
                        Nossos agentes são programados para atuar exatamente como um membro do seu time — com atendimento humanizado, respostas rápidas e integração total com o CRM e o WhatsApp.
                      </p>
                      
                      <p className="text-gray-700 leading-relaxed mb-6">
                        Com base em estratégias de Neurovendas e Inteligência Conversacional, nossos agentes entendem o comportamento do cliente, qualificam oportunidades e conduzem interações de forma estratégica e natural.
                      </p>
                    </div>

                    {/* Tipos de Agentes */}
                    <div className="bg-gray-50 rounded-xl p-6">
                      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-robot-line text-yellow-500"></i>
                        Tipos de Agentes disponíveis:
                      </h3>
                      
                      <div className="space-y-4">
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-search-line text-white text-sm"></i>
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">💬 Agente SDR (Prospecção e Qualificação):</p>
                            <p className="text-gray-700 text-sm">faz a triagem dos leads, identifica oportunidades e entrega apenas contatos prontos para o fechamento.</p>
                          </div>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-whatsapp-line text-white text-sm"></i>
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">🧭 Agente de Atendimento via WhatsApp:</p>
                            <p className="text-gray-700 text-sm">responde dúvidas frequentes, fornece informações e mantém o cliente sempre engajado.</p>
                          </div>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-calendar-line text-white text-sm"></i>
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">📅 Agente de Agendamento:</p>
                            <p className="text-gray-700 text-sm">realiza marcações automáticas integradas ao Google Agenda e CRM.</p>
                          </div>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-refresh-line text-white text-sm"></i>
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">🔁 Agente de Follow-up:</p>
                            <p className="text-gray-700 text-sm">faz acompanhamentos automáticos com mensagens personalizadas para reengajar leads e evitar perda de oportunidades.</p>
                          </div>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-money-dollar-circle-line text-white text-sm"></i>
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">💼 Agente de Vendas:</p>
                            <p className="text-gray-700 text-sm">conduz o cliente pela jornada comercial até a conversão, com argumentação estruturada e gatilhos de persuasão.</p>
                          </div>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-heart-line text-white text-sm"></i>
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">🤝 Agente de Pós-venda:</p>
                            <p className="text-gray-700 text-sm">mantém o relacionamento ativo, solicita feedbacks e estimula recompra e fidelização.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Por que escolher */}
                    <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-xl p-6 border border-yellow-200">
                      <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-star-line text-yellow-500"></i>
                        Por que escolher a M4 Digital:
                      </h3>
                      
                      <div className="space-y-3">
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-yellow-500"></i>
                          <p className="text-gray-700">Criação de agentes sob medida alinhados à realidade do seu negócio.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-yellow-500"></i>
                          <p className="text-gray-700">Integração com CRM, WhatsApp API, planilhas e sistemas internos.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-yellow-500"></i>
                          <p className="text-gray-700">Redução de custos operacionais e aumento da produtividade da equipe.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-yellow-500"></i>
                          <p className="text-gray-700">Atendimento 24h, com precisão, velocidade e consistência.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-yellow-500"></i>
                          <p className="text-gray-700">Resultados mensuráveis e escaláveis.</p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-xl p-6 border border-yellow-200">
                      <p className="text-lg font-semibold text-gray-900 text-center">
                        Com os Agentes de IA da M4 Digital, sua empresa opera com 
                        <span className="text-yellow-600"> eficiência exponencial</span> — enquanto a tecnologia cuida do operacional, seu time foca no estratégico e nas vendas.
                      </p>
                    </div>
                  </div>

                  {/* Right Content - AI Dashboard Image */}
                  <div className="space-y-6">
                    <div className="bg-gray-900 rounded-xl p-6">
                      <img 
                        src="https://readdy.ai/api/search-image?query=Advanced%20AI%20agent%20dashboard%20interface%20with%20conversational%20AI%20analytics%2C%20chatbot%20performance%20metrics%2C%20automated%20workflow%20visualization%2C%20intelligent%20conversation%20tracking%2C%20lead%20qualification%20analytics%2C%20yellow%20and%20orange%20color%20scheme%2C%20futuristic%20AI%20technology%20interface%2C%20real-time%20agent%20performance%20data%2C%20customer%20interaction%20analytics%2C%20machine%20learning%20insights%20dashboard&width=600&height=400&seq=ai-agent-dashboard&orientation=landscape"
                        alt="Dashboard Agentes de IA M4 Digital"
                        className="w-full h-64 object-cover rounded-lg"
                      />
                      <div className="mt-4 text-center">
                        <p className="text-white text-sm">Dashboard Agentes de IA M4 Digital</p>
                        <p className="text-gray-400 text-xs">Inteligência artificial em ação</p>
                      </div>
                    </div>

                    {/* Metrics Cards */}
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-yellow-50 rounded-lg p-4 text-center border border-yellow-200">
                        <div className="text-2xl font-bold text-yellow-600">24/7</div>
                        <div className="text-sm text-gray-600">Atendimento</div>
                      </div>
                      <div className="bg-orange-50 rounded-lg p-4 text-center border border-orange-200">
                        <div className="text-2xl font-bold text-orange-600">-70%</div>
                        <div className="text-sm text-gray-600">Custos Operacionais</div>
                      </div>
                      <div className="bg-green-50 rounded-lg p-4 text-center border border-green-200">
                        <div className="text-2xl font-bold text-green-600">90%</div>
                        <div className="text-sm text-gray-600">Qualificação Precisa</div>
                      </div>
                      <div className="bg-blue-50 rounded-lg p-4 text-center border border-blue-200">
                        <div className="text-2xl font-bold text-blue-600">5x</div>
                        <div className="text-sm text-gray-600">Mais Produtividade</div>
                      </div>
                    </div>

                    {/* CTA Buttons */}
                    <div className="space-y-3">
                      <button 
                        onClick={scrollToDiagnosticAndClosePopup}
                        className="w-full bg-gradient-to-r from-yellow-500 to-orange-500 text-white py-4 px-6 rounded-lg font-semibold hover:from-yellow-600 hover:to-orange-600 transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-calendar-line mr-2"></i>
                        Agendar Consultoria Gratuita
                      </button>
                      <button 
                        onClick={openWhatsApp}
                        className="w-full border-2 border-yellow-500 text-yellow-600 py-4 px-6 rounded-lg font-semibold hover:bg-yellow-50 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-whatsapp-line mr-2"></i>
                        Falar com Especialista
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* WhatsApp API Popup */}
      {activePopup === 'whatsapp-api' && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closePopup();
            }
          }}
        >
          <div className="relative max-w-5xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-white rounded-2xl shadow-2xl">
              {/* Header */}
              <div className="relative bg-gradient-to-r from-green-500 to-teal-500 p-8 rounded-t-2xl text-white">
                <button 
                  onClick={closePopup}
                  className="absolute top-4 right-4 text-white hover:text-gray-200 text-2xl w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line"></i>
                </button>
                
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center">
                    <i className="ri-whatsapp-line text-3xl"></i>
                  </div>
                  <div>
                    <h2 className="text-3xl font-bold">💬 WhatsApp Cloud API Oficial – Comunicação Inteligente e Escalável</h2>
                    <p className="text-xl opacity-90 mt-2">Atendimento profissional, seguro e automatizado com tecnologia oficial da Meta.</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="grid lg:grid-cols-2 gap-8">
                  {/* Left Content */}
                  <div className="space-y-6">
                    <div>
                      <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        A M4 Digital é <strong>parceira oficial da Meta (Meta Partners)</strong> e oferece a implementação completa do WhatsApp Cloud API Oficial, a solução ideal para empresas que desejam escalar o atendimento, automatizar vendas e centralizar toda a comunicação com clientes em um único número.
                      </p>
                      
                      <p className="text-gray-700 leading-relaxed mb-6">
                        <strong>Cuidamos de todo o processo:</strong> desde a criação da conta oficial junto à Meta, verificação da empresa e configuração técnica da API, até o desenvolvimento das estratégias e fluxos automatizados de atendimento, vendas e pós-venda.
                      </p>
                    </div>

                    {/* O que sua empresa ganha */}
                    <div className="bg-gray-50 rounded-xl p-6">
                      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-whatsapp-line text-green-500"></i>
                        Com o WhatsApp Cloud API da M4 Digital, sua empresa ganha:
                      </h3>
                      
                      <div className="space-y-4">
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-team-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Atendimento ilimitado com múltiplos operadores no mesmo número.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-robot-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Chatbots inteligentes integrados ao CRM e sistemas internos.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-flow-chart text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Fluxos automáticos de boas-vindas, agendamento, follow-up e reengajamento.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-send-plane-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Disparo de campanhas em massa com segurança e rastreabilidade.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-bar-chart-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Relatórios avançados com métricas de desempenho e tempo de resposta.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-shield-check-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Comunicação 100% segura, estável e à prova de bloqueios.</p>
                        </div>
                      </div>
                    </div>

                    {/* Estratégia completa */}
                    <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-xl p-6 border border-green-200">
                      <p className="text-gray-700 leading-relaxed mb-4">
                        Além da implementação técnica, criamos toda a <strong>estratégia de uso da API</strong> — desde a estrutura das mensagens até os gatilhos de conversão e automações inteligentes que garantem uma experiência fluida e personalizada para cada cliente.
                      </p>
                      
                      <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-trophy-line text-green-500"></i>
                        Resultados comprovados:
                      </h3>
                      
                      <div className="space-y-3">
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-green-500"></i>
                          <p className="text-gray-700">Redução de até 50% no tempo médio de atendimento.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-green-500"></i>
                          <p className="text-gray-700">Aumento médio de 35% nas vendas com automação.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-green-500"></i>
                          <p className="text-gray-700">Padronização, agilidade e escalabilidade no relacionamento com o cliente.</p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-xl p-6 border border-green-200">
                      <p className="text-lg font-semibold text-gray-900 text-center">
                        Com a M4 Digital, sua empresa não apenas utiliza o WhatsApp — ela 
                        <span className="text-green-600"> domina o canal mais poderoso de comunicação do mundo</span> com inteligência e estratégia.
                      </p>
                    </div>
                  </div>

                  {/* Right Content - WhatsApp Dashboard Image */}
                  <div className="space-y-6">
                    <div className="bg-gray-900 rounded-xl p-6">
                      <img 
                        src="https://readdy.ai/api/search-image?query=Professional%20WhatsApp%20Business%20API%20dashboard%20interface%20with%20message%20automation%20analytics%2C%20chatbot%20conversation%20flows%2C%20customer%20engagement%20metrics%2C%20mass%20campaign%20management%2C%20green%20and%20teal%20color%20scheme%2C%20modern%20communication%20platform%20interface%2C%20real-time%20messaging%20analytics%2C%20automated%20response%20tracking%2C%20customer%20service%20performance%20dashboard&width=600&height=400&seq=whatsapp-api-dashboard&orientation=landscape"
                        alt="Dashboard WhatsApp API M4 Digital"
                        className="w-full h-64 object-cover rounded-lg"
                      />
                      <div className="mt-4 text-center">
                        <p className="text-white text-sm">WhatsApp Cloud API M4 Digital</p>
                        <p className="text-gray-400 text-xs">Comunicação oficial da Meta</p>
                      </div>
                    </div>

                    {/* Metrics Cards */}
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-green-50 rounded-lg p-4 text-center border border-green-200">
                        <div className="text-2xl font-bold text-green-600">-50%</div>
                        <div className="text-sm text-gray-600">Tempo de Atendimento</div>
                      </div>
                      <div className="bg-teal-50 rounded-lg p-4 text-center border border-teal-200">
                        <div className="text-2xl font-bold text-teal-600">+35%</div>
                        <div className="text-sm text-gray-600">Vendas com Automação</div>
                      </div>
                      <div className="bg-blue-50 rounded-lg p-4 text-center border border-blue-200">
                        <div className="text-2xl font-bold text-blue-600">100%</div>
                        <div className="text-sm text-gray-600">Segurança Oficial</div>
                      </div>
                      <div className="bg-purple-50 rounded-lg p-4 text-center border border-purple-200">
                        <div className="text-2xl font-bold text-purple-600">∞</div>
                        <div className="text-sm text-gray-600">Operadores</div>
                      </div>
                    </div>

                    {/* Meta Partner Badge */}
                    <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 border border-blue-200 text-center">
                      <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-verified-badge-line text-white text-2xl"></i>
                      </div>
                      <h4 className="text-lg font-bold text-gray-900 mb-2">Meta Partners Oficial</h4>
                      <p className="text-sm text-gray-600">Parceiro certificado da Meta para WhatsApp Business API</p>
                    </div>

                    {/* CTA Buttons */}
                    <div className="space-y-3">
                      <button 
                        onClick={scrollToDiagnosticAndClosePopup}
                        className="w-full bg-gradient-to-r from-green-500 to-teal-500 text-white py-4 px-6 rounded-lg font-semibold hover:from-green-600 hover:to-teal-600 transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-calendar-line mr-2"></i>
                        Agendar Consultoria Gratuita
                      </button>
                      <button 
                        onClick={openWhatsApp}
                        className="w-full border-2 border-green-500 text-green-600 py-4 px-6 rounded-lg font-semibold hover:bg-green-50 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-whatsapp-line mr-2"></i>
                        Falar com Especialista
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Lançamentos Estratégicos Popup */}
      {activePopup === 'lancamentos' && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closePopup();
            }
          }}
        >
          <div className="relative max-w-5xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-white rounded-2xl shadow-2xl">
              {/* Header */}
              <div className="relative bg-gradient-to-r from-orange-500 to-red-500 p-8 rounded-t-2xl text-white">
                <button 
                  onClick={closePopup}
                  className="absolute top-4 right-4 text-white hover:text-gray-200 text-2xl w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line"></i>
                </button>
                
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center">
                    <i className="ri-rocket-line text-3xl"></i>
                  </div>
                  <div>
                    <h2 className="text-3xl font-bold">⚡ Lançamentos via WhatsApp – Estratégia Caixa Rápido</h2>
                    <p className="text-xl opacity-90 mt-2">Venda em um único dia o que muitos demoram um mês para faturar.</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="grid lg:grid-cols-2 gap-8">
                  {/* Left Content */}
                  <div className="space-y-6">
                    <div>
                      <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        A M4 Digital é especialista em estratégias de lançamentos comerciais de alta conversão, e o nosso maior diferencial é o <strong>método Caixa Rápido</strong> — uma estratégia exclusiva que transforma o WhatsApp em uma verdadeira máquina de vendas relâmpago.
                      </p>
                      
                      <p className="text-gray-700 leading-relaxed mb-6">
                        Com o Caixa Rápido, planejamos e executamos ações concentradas e altamente estratégicas capazes de gerar picos de vendas em poucas horas, utilizando gatilhos de escassez, desejo e pertencimento.
                        É uma metodologia validada em dezenas de campanhas, com resultados que já ultrapassaram <strong>R$ 100 mil em faturamento em apenas um dia</strong>.
                      </p>
                    </div>

                    {/* Como funciona */}
                    <div className="bg-gray-50 rounded-xl p-6">
                      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-settings-line text-orange-500"></i>
                        Como funciona:
                      </h3>
                      
                      <div className="space-y-4">
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-file-list-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Planejamento completo da ação: roteiro estratégico, copywriting persuasivo e estrutura emocional de lançamento.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-group-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Criação e gestão de grupos exclusivos no WhatsApp.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-message-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Envio de mensagens e conteúdos com storytelling e gatilhos mentais.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-time-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Abertura e fechamento das vendas com senso de urgência real.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-bar-chart-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Relatórios e acompanhamento de performance em tempo real.</p>
                        </div>
                      </div>
                    </div>

                    {/* Benefícios */}
                    <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-6 border border-orange-200">
                      <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-trophy-line text-orange-500"></i>
                        Benefícios da Estratégia Caixa Rápido:
                      </h3>
                      
                      <div className="space-y-3">
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-orange-500"></i>
                          <p className="text-gray-700">Aumento expressivo de receita em curtíssimo prazo.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-orange-500"></i>
                          <p className="text-gray-700">Mobilização de toda a base de clientes em uma única campanha.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-orange-500"></i>
                          <p className="text-gray-700">Estímulo emocional de compra em massa.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-orange-500"></i>
                          <p className="text-gray-700">Reativação de clientes antigos e fortalecimento da marca.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-orange-500"></i>
                          <p className="text-gray-700">Estratégia 100% replicável para novas ações mensais.</p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-6 border border-orange-200">
                      <p className="text-lg font-semibold text-gray-900 text-center">
                        Com o Caixa Rápido da M4 Digital, sua empresa deixa de depender de vendas constantes e imprevisíveis e passa a gerar 
                        <span className="text-orange-600"> explosões de faturamento com precisão cirúrgica</span> — tudo através de estratégia, copy e automação inteligente via WhatsApp.
                      </p>
                    </div>
                  </div>

                  {/* Right Content - Sales Peak Dashboard Image */}
                  <div className="space-y-6">
                    <div className="bg-gray-900 rounded-xl p-6">
                      <img 
                        src="https://readdy.ai/api/search-image?query=WhatsApp%20sales%20campaign%20dashboard%20with%20explosive%20sales%20peaks%20visualization%2C%20real-time%20revenue%20spikes%20analytics%2C%20flash%20sales%20performance%20metrics%2C%20group%20messaging%20campaign%20tracking%2C%20orange%20and%20red%20color%20scheme%2C%20dramatic%20sales%20growth%20charts%2C%20instant%20revenue%20generation%20interface%2C%20lightning-fast%20sales%20conversion%20analytics%2C%20WhatsApp%20marketing%20automation%20dashboard&width=600&height=400&seq=sales-peak-dashboard&orientation=landscape"
                        alt="Dashboard Lançamentos Estratégicos M4 Digital"
                        className="w-full h-64 object-cover rounded-lg"
                      />
                      <div className="mt-4 text-center">
                        <p className="text-white text-sm">Dashboard Caixa Rápido M4 Digital</p>
                        <p className="text-gray-400 text-xs">Picos de vendas via WhatsApp</p>
                      </div>
                    </div>

                    {/* Metrics Cards */}
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-orange-50 rounded-lg p-4 text-center border border-orange-200">
                        <div className="text-2xl font-bold text-orange-600">R$ 100k+</div>
                        <div className="text-sm text-gray-600">Em 1 Dia</div>
                      </div>
                      <div className="bg-red-50 rounded-lg p-4 text-center border border-red-200">
                        <div className="text-2xl font-bold text-red-600">24h</div>
                        <div className="text-sm text-gray-600">Campanha Relâmpago</div>
                      </div>
                      <div className="bg-yellow-50 rounded-lg p-4 text-center border border-yellow-200">
                        <div className="text-2xl font-bold text-yellow-600">95%</div>
                        <div className="text-sm text-gray-600">Taxa de Abertura</div>
                      </div>
                      <div className="bg-green-50 rounded-lg p-4 text-center border border-green-200">
                        <div className="text-2xl font-bold text-green-600">100%</div>
                        <div className="text-sm text-gray-600">Replicável</div>
                      </div>
                    </div>

                    {/* Resultado Destaque */}
                    <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-xl p-6 border border-yellow-200 text-center">
                      <div className="w-16 h-16 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-flashlight-line text-white text-2xl"></i>
                      </div>
                      <h4 className="text-lg font-bold text-gray-900 mb-2">Método Caixa Rápido</h4>
                      <p className="text-sm text-gray-600">Estratégia exclusiva validada em dezenas de campanhas</p>
                    </div>

                    {/* CTA Buttons */}
                    <div className="space-y-3">
                      <button 
                        onClick={scrollToDiagnosticAndClosePopup}
                        className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-4 px-6 rounded-lg font-semibold hover:from-orange-600 hover:to-red-600 transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-calendar-line mr-2"></i>
                        Agendar Consultoria Gratuita
                      </button>
                      <button 
                        onClick={openWhatsApp}
                        className="w-full border-2 border-orange-500 text-orange-600 py-4 px-6 rounded-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-whatsapp-line mr-2"></i>
                        Falar com Especialista
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Reativação de Leads Popup */}
      {activePopup === 'reativacao-leads' && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closePopup();
            }
          }}
        >
          <div className="relative max-w-5xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-white rounded-2xl shadow-2xl">
              {/* Header */}
              <div className="relative bg-gradient-to-r from-red-500 to-pink-500 p-8 rounded-t-2xl text-white">
                <button 
                  onClick={closePopup}
                  className="absolute top-4 right-4 text-white hover:text-gray-200 text-2xl w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line"></i>
                </button>
                
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center">
                    <i className="ri-user-heart-line text-3xl"></i>
                  </div>
                  <div>
                    <h2 className="text-3xl font-bold">🔄 Reativa+ – Estratégia Inteligente de Reativação de Leads</h2>
                    <p className="text-xl opacity-90 mt-2">Transforme sua base parada em novas vendas com inteligência e propósito.</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="grid lg:grid-cols-2 gap-8">
                  {/* Left Content */}
                  <div className="space-y-6">
                    <div>
                      <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        Na M4 Digital, desenvolvemos o <strong>Reativa+</strong>, uma estratégia exclusiva de reativação de leads e clientes inativos, criada para ressuscitar bases esquecidas e transformá-las novamente em oportunidades reais de vendas.
                      </p>
                      
                      <p className="text-gray-700 leading-relaxed mb-6">
                        Combinando <strong>Inteligência de Dados, Copywriting de Alta Conversão e Psicologia de Vendas</strong>, elaboramos campanhas personalizadas de resgate via WhatsApp, capazes de impactar emocionalmente toda a sua base de contatos — e gerar resultados imediatos.
                      </p>
                    </div>

                    {/* Como funciona */}
                    <div className="bg-gray-50 rounded-xl p-6">
                      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-settings-line text-red-500"></i>
                        Como funciona:
                      </h3>
                      
                      <div className="space-y-4">
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-search-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Analisamos sua base de contatos e identificamos perfis com maior potencial de retorno.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-pink-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-message-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Criamos mensagens estrategicamente planejadas para reconectar, despertar interesse e gerar resposta imediata.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-send-plane-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Executamos o disparo em massa via API Oficial da Meta ou Disparador Inteligente com IA, garantindo alta taxa de entrega e segurança.</p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <i className="ri-bar-chart-line text-white text-sm"></i>
                          </div>
                          <p className="text-gray-700">Monitoramos as respostas e acompanhamos a performance de conversão.</p>
                        </div>
                      </div>
                    </div>

                    {/* Resultados reais */}
                    <div className="bg-gradient-to-r from-red-50 to-pink-50 rounded-xl p-6 border border-red-200">
                      <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-trophy-line text-red-500"></i>
                        Resultados reais:
                      </h3>
                      
                      <p className="text-gray-700 leading-relaxed mb-4">
                        Nossos clientes têm alcançado entre <strong>5% e 17% de reativação efetiva</strong>, convertendo contatos antigos em novas vendas e faturamento adicional — sem precisar investir mais em mídia paga.
                      </p>
                    </div>

                    {/* Por que é diferente */}
                    <div className="bg-gradient-to-r from-red-50 to-pink-50 rounded-xl p-6 border border-red-200">
                      <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <i className="ri-star-line text-red-500"></i>
                        Por que o Reativa+ é diferente:
                      </h3>
                      
                      <div className="space-y-3">
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-red-500"></i>
                          <p className="text-gray-700">Estratégia cuidadosamente planejada para gerar impacto positivo e conversão rápida.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-red-500"></i>
                          <p className="text-gray-700">Comunicação empática e humanizada, focada em reativar desejo e confiança.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-red-500"></i>
                          <p className="text-gray-700">Execução técnica e estratégica conduzida por especialistas em Neurovendas e Automação.</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-check-line text-red-500"></i>
                          <p className="text-gray-700">Campanhas replicáveis para rodar periodicamente com resultados consistentes.</p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gradient-to-r from-red-50 to-pink-50 rounded-xl p-6 border border-red-200">
                      <p className="text-lg font-semibold text-gray-900 text-center">
                        Com o Reativa+ da M4 Digital, você transforma uma base esquecida em uma 
                        <span className="text-red-600"> mina de ouro comercial</span>, aumentando o faturamento e fortalecendo o relacionamento com seus clientes — tudo com inteligência estratégica e foco total em conversão.
                      </p>
                    </div>
                  </div>

                  {/* Right Content - Lead Reactivation Dashboard Image */}
                  <div className="space-y-6">
                    <div className="bg-gray-900 rounded-xl p-6">
                      <img 
                        src="https://readdy.ai/api/search-image?query=Lead%20reactivation%20dashboard%20interface%20with%20customer%20re-engagement%20analytics%2C%20dormant%20lead%20revival%20metrics%2C%20WhatsApp%20campaign%20performance%20tracking%2C%20conversion%20resurrection%20charts%2C%20red%20and%20pink%20color%20scheme%2C%20intelligent%20lead%20scoring%20visualization%2C%20automated%20follow-up%20sequences%2C%20customer%20lifecycle%20analytics%2C%20reactivation%20success%20rates%20dashboard&width=600&height=400&seq=lead-reactivation-dashboard&orientation=landscape"
                        alt="Dashboard Reativação de Leads M4 Digital"
                        className="w-full h-64 object-cover rounded-lg"
                      />
                      <div className="mt-4 text-center">
                        <p className="text-white text-sm">Dashboard Reativa+ M4 Digital</p>
                        <p className="text-gray-400 text-xs">Inteligência de reativação de leads</p>
                      </div>
                    </div>

                    {/* Metrics Cards */}
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-red-50 rounded-lg p-4 text-center border border-red-200">
                        <div className="text-2xl font-bold text-red-600">5-17%</div>
                        <div className="text-sm text-gray-600">Taxa de Reativação</div>
                      </div>
                      <div className="bg-pink-50 rounded-lg p-4 text-center border border-pink-200">
                        <div className="text-2xl font-bold text-pink-600">0</div>
                        <div className="text-sm text-gray-600">Investimento em Mídia</div>
                      </div>
                      <div className="bg-purple-50 rounded-lg p-4 text-center border border-purple-200">
                        <div className="text-2xl font-bold text-purple-600">100%</div>
                        <div className="text-sm text-gray-600">Segurança API</div>
                      </div>
                      <div className="bg-orange-50 rounded-lg p-4 text-center border border-orange-200">
                        <div className="text-2xl font-bold text-orange-600">∞</div>
                        <div className="text-sm text-gray-600">Campanhas Replicáveis</div>
                      </div>
                    </div>

                    {/* Reativa+ Method Badge */}
                    <div className="bg-gradient-to-r from-red-50 to-pink-50 rounded-xl p-6 border border-red-200 text-center">
                      <div className="w-16 h-16 bg-gradient-to-r from-red-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-refresh-line text-white text-2xl"></i>
                      </div>
                      <h4 className="text-lg font-bold text-gray-900 mb-2">Método Reativa+</h4>
                      <p className="text-sm text-gray-600">Estratégia exclusiva de ressurreição de leads</p>
                    </div>

                    {/* CTA Buttons */}
                    <div className="space-y-3">
                      <button 
                        onClick={scrollToDiagnosticAndClosePopup}
                        className="w-full bg-gradient-to-r from-red-500 to-pink-500 text-white py-4 px-6 rounded-lg font-semibold hover:from-red-600 hover:to-pink-600 transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-calendar-line mr-2"></i>
                        Agendar Consultoria Gratuita
                      </button>
                      <button 
                        onClick={openWhatsApp}
                        className="w-full border-2 border-red-500 text-red-600 py-4 px-6 rounded-lg font-semibold hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-whatsapp-line mr-2"></i>
                        Falar com Especialista
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
